import {Outlet} from 'react-router-dom'
import {StyledPrivateLayout} from './style.ts'
import {Navbar} from '@components/commons/navbar/Navbar.tsx'
import {InternalConversationsProvider} from '@/features/conversations/components/internal-conversations-provider/InternalConversationsProvider'

export const PrivateLayout = () => {
    return (
        <StyledPrivateLayout>
            <Navbar />
            <Outlet />
            {/* Internal conversations drawer: mounted once for every authenticated route
                so it survives navigation and can be opened from the account menu or
                from conversation notifications without a link */}
            <InternalConversationsProvider />
        </StyledPrivateLayout>
    )
}
